import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state to display the fallback UI when an error occurs
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error or send it to an error tracking service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Display the fallback UI, e.g., an error message
      return <div>Something went wrong. Please try again later.</div>;
    }

    // If no error, render the children (the wrapped components)
    return this.props.children;
  }
}

export default ErrorBoundary;
